export default __webpack_public_path__ + "static/media/sportsbra-medium-front-toosmall.29896fe9.jpg";